import {validateColorAndPerformCastingIfNecessary} from '../../../privates/validations/styleValidation';
import styleService from './styleService';
import * as members from '../../../privates/privateMembers';
import StyleProperties from '../../../privates/styleConstants';
/*
 * @mixin TextColorMixin
 * @summary Provides functionality for changing an element's text color.
 *
 * @memberof $w.Style
 */
class TextColorMixin {

  /**
   * @member color
   * @memberof $w.Style
   * @param {external:String} color
   */
    set color(color) {
        const compName = members._compName.get(this);
        const opacitySupport = false;

        const validColor = validateColorAndPerformCastingIfNecessary(color, opacitySupport, StyleProperties.COLOR, compName);
        if (!validColor){
            return;
        }
        styleService.setStyle.call(this, StyleProperties.COLOR, validColor);
    }

    /**
     * @member color
     * @label property
     * @syntax
     * get color(): string
     * set color(rgbColor: string): void
     * @summary Sets or gets the text color of an element.
     * @description
     *  The text color value is a string representing an rgb color in one
     *  of the following formats:
     *
     *  + `"red"`: One of [140 predefined color names](https://www.w3schools.com/colors/colors_names.asp).
     *  + `"#FF0000"`: A hexidecimal rgb color value.
     *  + `"rgb(255,0,0)"`: An rgb() function color value.
     * 
     * This style can be used with the following elements: 
     * 
     *  + [`Button`]($w.Button.html)
     *  + [`CheckboxGroup`]($w.CheckboxGroup.html)
     *  + [`Dropdown`]($w.Dropdown.html)
     *  + [`RadioButtonGroup`]($w.RadioButtonGroup.html)
     *  + [`TextBox`]($w.TextBox.html)
     *  + [`TextInput`]($w.TextInput.html) 
     *  + [`UploadButton`]($w.UploadButton.html)
     * 
     * @snippet [TextColorMixin-color_set.es6=Set the text color]
     * @snippet [TextColorMixin-color_get.es6=Get the text color]
     * @type {external:String}
     * @memberof $w.Style
     * @instance
     */
    get color() {
       return styleService.getStyleParamValue.call(this, StyleProperties.COLOR);
    }

}

export default TextColorMixin;
